import(/* webpackMode: "eager" */ "/app/app/[lng]/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/app/app/[lng]/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/SessionExpiryModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/redux-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClickCounterContextProvider"] */ "/app/context/ClickCounter.context.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
